import { Button } from '../Button';
import { Spinner } from '../Spinner';
import { Description, TextGroup, Title, Wrapper } from './InlineFeedback.styles';
import type { InlineFeedbackProps } from './InlineFeedback.types';

export function InlineFeedback({
  title,
  description,
  actionLabel,
  onAction,
  isActionPending = false,
}: InlineFeedbackProps) {
  return (
    <Wrapper role="status">
      <TextGroup>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </TextGroup>
      {actionLabel && onAction && (
        <Button
          variant="neutral"
          size="small"
          aria-busy={isActionPending || undefined}
          onClick={isActionPending ? undefined : onAction}
        >
          {isActionPending && <Spinner tone="inherit" aria-hidden />}
          {actionLabel}
        </Button>
      )}
    </Wrapper>
  );
}
